import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, StatusBadge, EmptyState } from "@/components/dashboard/ui";

export default function Clients() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data.events)).catch(() => setEvents([])); }, []);
  if (!events) return <Loader />;

  return (
    <div>
      <PageHeader title="Clients" subtitle="Everyone you're delivering galleries to." />
      {events.length === 0 ? <EmptyState icon={Users} title="No clients yet" desc="Create an event to add your first client." /> : (
        <div className="rounded-2xl border border-border overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-5 py-3 bg-black/40 text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
            <div className="col-span-3">Client</div><div className="col-span-4">Event</div><div className="col-span-2">Photos</div><div className="col-span-2">Selected</div><div className="col-span-1">Status</div>
          </div>
          {events.map((e) => (
            <Link key={e.id} to={`/app/events/${e.id}?tab=selections`} data-testid={`client-row-${e.id}`}
              className="grid grid-cols-2 sm:grid-cols-12 gap-2 sm:gap-4 px-5 py-4 items-center border-b border-border last:border-0 hover:bg-white/[0.03] transition-colors">
              <div className="col-span-2 sm:col-span-3 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-gold/15 text-gold flex items-center justify-center text-sm font-medium">{e.client_name.charAt(0)}</div>
                <span className="text-white text-sm font-medium">{e.client_name}</span>
              </div>
              <div className="col-span-2 sm:col-span-4 text-sm text-secondary-foreground">{e.name}</div>
              <div className="sm:col-span-2 text-sm text-muted-foreground">{e.photo_count}</div>
              <div className="sm:col-span-2 text-sm text-muted-foreground">{e.selected_count}</div>
              <div className="sm:col-span-1"><StatusBadge status={e.selection_status} /></div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
